import { render, staticRenderFns } from "./OmsTabs.vue?vue&type=template&id=650ed77d"
import script from "./OmsTabs.vue?vue&type=script&lang=js"
export * from "./OmsTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports